import Vue from 'vue';
import VueRouter from 'vue-router'
import App from './App.vue';
import "bootstrap";
import {library} from "@fortawesome/fontawesome-svg-core";
import "bootstrap/dist/css/bootstrap.css";
import "animate.css/animate.css";
import vuetify from '@/plugins/vuetify';
import VueI18n from 'vue-i18n';
import messages from './lang';
import Vue2Editor from 'vue2-editor';
import Toasted from 'vue-toasted';
//import AudioRecorder from 'vue-audio-recorder';

// tmp deactive
//import VueRecord from '@codekraft-studio/vue-record';
import VueWaveSurfer from 'vue-wave-surfer';
import VModal from 'vue-js-modal';
// import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
// import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import VueLazyload from 'vue-lazyload';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';

import store from './helper/store.js';

import {
  faBrain,
  faBoxes
} from "@fortawesome/free-solid-svg-icons";

import './assets/css/tagsinput.css';
import './assets/css/style.css';

// import Stage from "./components/Stage.vue";
// import NLP from "./components/NLP.vue";
//import NLPtest from "./components/NLPtest.vue";
// import Chatbot from "./components/Chatbot.vue";
// import NAO from "./components/NAO.vue";
import UsecaseFrame from "./components/UsecaseFrame.vue";

import Profile from "./components/Profile.vue";
import AdminContent from "./components/AdminContent.vue";
import Content from "./components/Content.vue";
import Contents from "./components/Contents.vue";
import Login from "./components/Login.vue";
import PageNotFound from "./components/PageNotFound.vue";

import Node from "./components/Node.vue";
import NodeAdd from "./components/NodeAdd.vue";

//import Space from "./components/Space.vue";
//import SpaceBib from "./components/SpaceBib.vue";

// import Panorama from "./components/Panorama.vue";
// import PanoramaFrame from "./components/PanoramaFrame.vue";
import Suche from "./components/Suche.vue";
import Thema from "./components/Thema.vue";
import Home from "./components/Home.vue";
import Imprint from "./components/Imprint.vue";
import Privacy from "./components/Privacy.vue";
import Virtuell from "./components/Virtuell.vue";


library.add(faBrain, faBoxes);

// GLOBALs
function host(url) {
  var host;
  switch (url) {
    case 'localhost':
      host = 'local';
      break;
    case 'testbed.innohub13.de':
      host = 'testbed';
      break;
    case 'testbeddev.innohub13.de':
      host = 'testbed';
      break;
    case 'icampus.th-wildau.de':
      host = 'icampus';
      break;
  }  
  return host
}

Vue.prototype.$host = host(location.hostname);
Vue.prototype.$template = 'default';
Vue.prototype.$panoData = [];
// var $home = Vue.prototype.$template === 'default' ? "transferpass/" : "";
var $home = Vue.prototype.$template === 'default' ? "" : "";
Vue.prototype.$home = $home;
//var naoserver = process.env.VUE_APP_NAOSERVER || '/naoserver/';

Vue.prototype.$config = {
    host: process.env.VUE_APP_BACKEND_HOST || 'https://icampusdev.th-wildau.de/transferbackend',
    web: process.env.VUE_APP_FRONTEND_HOST || 'https://icampusdev.th-wildau.de/transferpass',
    imagepath: process.env.VUE_APP_IMAGE_PATH || 'https://icampusdev.th-wildau.de/transferpass/files/images/',
    serviceurl: 'https://icampus.th-wildau.de/',
    accountInfoUrl: function(paramsSearch) {
      // return 'https://icampus.th-wildau.de/unidos/api/users/search/' + 
      return 'https://icampus.th-wildau.de/services.php?service=AccountInfo&action=employees&query=' + paramsSearch + '&using_version=1.4'
    },
    accountInfoParams: function() {
      var params = {    
        headers: { 
          // 'Authorization': 'Bearer 5|pdYwjYcDX8Y8MxxAe16Zigbu8wKgqgsuMun5WjTa',
          'Access-Control-Allow-Origin': '*'
        },
        data : ''
      }
      return params;
    },
    // imagepath: location.origin + '/files/images/',
    graphpath: process.env.VUE_APP_GRAPH_PATH || 'https://icampusdev.th-wildau.de/transferpass/graf/',
    // tb_host: process.env.VUE_APP_DSP_API_HOST || location.origin + '/dsp-api/',
};

Vue.use(VueI18n);
// console.log('CONFIG log:');
// console.log(Vue.prototype.$config);

export const i18n = new VueI18n({
  locale: 'de',
  fallbackLocale: 'de',
  messages
});

//Vue.use(abilitiesPlugin, ability);

Vue.use(VueRouter);
Vue.use(Vue2Editor);
Vue.use(VModal);
Vue.use(VueAxios, axios);
Vue.use(VueLazyload);
var toastoptions = {
    position: 'top-center',
    duration: 4000
}
Vue.use(Toasted, toastoptions);
//Vue.use(AudioRecorder);

// tmp deactive
//Vue.use(VueRecord);
Vue.use(VueWaveSurfer);

Vue.use(VueCookies);
// Vue.use(VueFilterDateFormat);
// Vue.use(VueFilterDateParse);

// Vue.use(vuetify);

axios.defaults.withCredentials = true;

//Generate random token:
const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

// set global cookie
Vue.$cookies.config('7d','','',true, 'None');
//Vue.$cookies.set('USERID',token, null, null, 'rosassdev.innohub13.de', true);
Vue.$cookies.set('USERID',token);
//Vue.$cookies.set('USERID',token,'7d','.innohub13.de' );

store.commit('clearUser');

Vue.config.productionTip = false;

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: "/"+$home,
      component: Home,
      name: "Home"
    },    
    {
      path: "/"+$home+"impressum",
      component: Imprint,
      name: "Imprint"
    },
    {
      path: "/"+$home+"datenschutz",
      component: Privacy,
      name: "Privacy"
    },    
    {
      path: "/"+$home+"virtuell",
      component: Virtuell,
      name: "Virtuell"      
    },
    {
      path: "/"+$home+"t/id/:url",
      component: UsecaseFrame,
      name: "UsecaseFrame",      
      props: (route) => ({         
        query: route.params.url
      })
    },
    {
      path: "/"+$home+"list",
      component: Profile,
      name: "List"
    },
    {
      path: "/"+$home+"admin",
      component: AdminContent,
      name: "Admin"
    },
    {
      path: "/"+$home+"content/:nodetype",
      component: AdminContent,
      name: "AdminContent"
    },
    {
      path: "/"+$home+"p/devices/:nodeid",
      component: Contents,
      name: "Contents",
      props: (route) => ({ nodeid: parseInt(route.query.nodeid) })
    },        
    {
      path: "/"+$home+"p/:nodetype/:nodeid",
      component: Content,
      name: "Content"      
    },
    {
      path: "/"+$home+"node/add/:nodetype",
      component: NodeAdd,
      name: "NodeAdd"
    },
    {
      path: "/"+$home+"node/:nodetype/:nodeid",
      component: Node,
      name: "Node"
    },
    {
      path: "/"+$home+"search",
      component: Suche,
      name: "Suche",
      props: (route) => ({         
        query: route.query.t
      })
    },
    /**
     * Suche nach Thema
     */
    {
      path: "/"+$home+"thema/:tagid",
      component: Thema,
      name: "Thema",
      props: (route) => ({         
        query: route.params.tagid
      })
    },
    {
      path: "/"+$home+"login",
      component: Login,
      name: "Login"
    },
    /**
     * URL alias
     */
    {
      path: "/"+$home+":url",
      component: Content,
      name: "Content",
      props: (route) => ({
        query: route.params.url
      })
    },    
    {
      path: "*",
      component: PageNotFound,
      name: "PageNotFound"
    }
  ],
  scrollBehavior() {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 0);
    return false; // Tell router not to handle scroll
    // return {x: 0, y: 0}
  }
})

/*
axios.get(Vue.prototype.$config.host + '/aliases')
  .then((response) => {
    response.data.forEach(r => {
      console.log('addRoute');
      console.log(r);
      router.addRoute({
        path: '/'+$home + r.alias,
        component: Content,
        name: "Content",
        props: () => ({ nodeid: parseInt(r.id) })
      });
    });
  })
  .catch(() => {
  })
*/

router.beforeEach((to, from, next) => {

  const adminContent = ['Node', 'NodeAdd', 'Admin', 'AdminContnet'];

  // console.log('to name:');
  // console.log(to.name);
  // console.log(store.state.user);

  if(
    Object.keys(store.state.user).length < 1 && 
    to.name !== 'Login' &&
    adminContent.includes(to.name)
    ) {

    // console.log('check user at server');

    axios.get(Vue.prototype.$config.host + '/user')
      .then((response) => {
        store.commit('setUser', response.data)
        next()
      })
      .catch(() => {
        next({
          path: Vue.prototype.$home + 'login',
          replace: true
        })
      })

  } else {
    next()
  }
})

export const eventBus = new Vue();

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
